import withProps from 'recompose/withProps';
import ShippingCost from './ShippingCost';
import upperFirst from 'lodash/upperFirst';

const enhance = withProps(props => {
  if (props.shipping) {
    const shippingType = Object.keys(props.shipping.deliveryDate)[0];
    return {
      shippingCost: upperFirst(
        `${shippingType} - ${props.shipmentTotal.formatted}`,
      ),
    };
  }
});

export default enhance(ShippingCost);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Shipping/ShippingCost/index.js